import { useLanguage } from "@/context/LanguageContext";
import { clearConsentPreferences } from "@/utils/consent";

const Footer = () => {
  const { copy } = useLanguage();

  const handleManageCookies = (event) => {
    event.preventDefault();
    clearConsentPreferences();
    window.location.reload();
  };

  return (
    <footer className="footer" data-testid="footer">
      <div className="container footer-container">
        <div className="footer-left" data-testid="footer-left">
          <p className="footer-text" data-testid="footer-text">
            {copy.footer.text}
          </p>
        </div>
        <div className="footer-right" data-testid="footer-right">
          <a href="/privacy" className="footer-link" data-testid="footer-privacy-link">
            {copy.footer.privacy}
          </a>
          <a
            href={copy.footer.linkedinUrl}
            className="footer-link"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-linkedin"
          >
            {copy.footer.linkedin}
          </a>
          <a
            href="#"
            className="footer-link"
            onClick={handleManageCookies}
            data-testid="footer-manage-cookies"
          >
            {copy.footer.manageCookies}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
